import type { StateCreator } from 'zustand'

export interface LiveEmoji {
  emojiSource: string
  liveId: number
  userId: number
}

interface State {
  liveEmojis: Record<string, LiveEmoji> | null
}

interface Actions {
  addLiveEmoji: (liveEmoji: LiveEmoji) => void
  removeLiveEmoji: (liveEmoji: LiveEmoji) => void
}

export type LiveEmojiSlice = State & Actions

export const liveEmojiStore: StateCreator<
  LiveEmojiSlice,
  [],
  [],
  LiveEmojiSlice
> = (set) => ({
  liveEmojis: null,
  addLiveEmoji: (liveEmoji) => {
    set((prevState) => ({
      liveEmojis: {
        ...prevState?.liveEmojis,
        [liveEmoji.userId]: liveEmoji,
      },
    }))
  },

  removeLiveEmoji: (liveEmoji) => {
    set((prevState) => {
      const newLiveEmoji = {
        ...prevState.liveEmojis,
      }

      delete newLiveEmoji[liveEmoji.userId]

      return {
        liveEmojis: newLiveEmoji,
      }
    })
  },
})
